import React, { useEffect, useRef } from 'react';

export default function CandleChart({ symbol, tf }) {
  const container = useRef(null);

  useEffect(() => {
    if (!container.current || !symbol) return;
    container.current.innerHTML = ""; 
    
    const tvInterval = {
      '1m': '1', '5m': '5', '15m': '15', '1h': '60', '4h': '240', '1d': 'D'
    }[tf] || '60';

    const tvSymbol = `BINANCE:${symbol.toUpperCase()}USDT`;
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: true, 
      symbol: tvSymbol, 
      interval: tvInterval,
      timezone: "Etc/UTC", 
      theme: "dark", 
      style: "1", 
      locale: "en",
      enable_publishing: false, 
      allow_symbol_change: true, 
      calendar: false,
      support_host: "https://www.tradingview.com"
    });
    
    container.current.appendChild(script);
  }, [symbol, tf]);

  if (!symbol) return <div style={{color: 'white', padding: '20px'}}>Loading...</div>;

  return (
    <div className="tradingview-widget-container" ref={container} style={{ height: "100%", width: "100%", minHeight: "500px" }}>
      <div className="tradingview-widget-container__widget" style={{ height: "100%", width: "100%" }}></div>
    </div>
  );
}
